import React from 'react';
import { Alert, Typography } from '@mui/material';

const InheritanceToast = ({ toast, onClose }) => {
  if (!toast) return null;
  return (
    <Alert
      severity="info"
      onClose={onClose}
      sx={{
        alignItems: 'flex-start',
        borderRadius: 1.5,
        borderLeft: '4px solid',
        borderLeftColor: 'info.main',
        '& .MuiAlert-icon': { alignItems: 'flex-start', pt: 0.5 },
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Round {toast.roundNumber} inherited {toast.total}{' '}
        review{toast.total === 1 ? '' : 's'} from the prior round.
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {toast.carriedVariance > 0 && (
          <>
            {toast.carriedVariance} still in variance — category, remediation,
            and notes carried forward so you don't re-investigate.{' '}
          </>
        )}
        {toast.resolved > 0 && (
          <>
            {toast.resolved} now matching — investigation history preserved in
            the <strong>Matches</strong> filter for later reference.
          </>
        )}
      </Typography>
    </Alert>
  );
};

export default InheritanceToast;
